import { SVGProps } from 'react'

export const DefaultAvatarIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none" {...props}>
      <circle cx="32" cy="32" r="32" fill="#E6E8EA" />
      <mask
        id="mask0_4005_142115"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="64"
        height="64"
      >
        <circle cx="32" cy="32" r="32" fill="#2A3037" />
      </mask>
      <g mask="url(#mask0_4005_142115)">
        <path
          d="M18.707 44.9999L31.5071 57.8L44.3071 44.9999V77H18.707V44.9999Z"
          fill="url(#paint0_linear_4005_142115)"
        />
        <path
          d="M31.5085 40.8624C22.4342 40.8622 15.0781 33.5054 15.0781 24.431C15.0781 15.3566 22.4341 8 31.5086 8C40.5829 8.00019 47.9393 15.3573 47.9393 24.4317C47.9393 33.5061 40.583 40.8624 31.5085 40.8624Z"
          fill="url(#paint1_linear_4005_142115)"
        />
        <path d="M52.1875 31.5077L55.1413 34.4615L58.0952 31.5077L55.1413 28.5539L52.1875 31.5077Z" fill="#E6E8EA" />
        <path d="M20.6797 8.12306L22.8951 10.3384L25.1105 8.12306L22.8951 5.90767L20.6797 8.12306Z" fill="#E6E8EA" />
        <path d="M6.89453 26.0923L8.37145 27.5692L9.84838 26.0923L8.37145 24.6154L6.89453 26.0923Z" fill="#E6E8EA" />
        <path d="M18.7094 45H10.1761C0.750397 45 -6.89062 52.641 -6.89062 62.0667V77.0001H18.7094V45Z" fill="#929AA5" />
        <path
          d="M44.3095 77.0001H69.9095V62.0667C69.9095 52.641 62.2685 45 52.8428 45H44.3095V77.0001Z"
          fill="#929AA5"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4005_142115"
          x1="31.5071"
          y1="77"
          x2="31.5071"
          y2="44.9999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B90B" />
          <stop offset="1" stopColor="#F8D33A" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4005_142115"
          x1="31.5087"
          y1="40.8624"
          x2="31.5087"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B90B" />
          <stop offset="1" stopColor="#F8D33A" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const ArrowLeft = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" width={24} height={24} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.934 12l3.89 3.89-1.769 1.767L8.398 12l1.768-1.768 3.89-3.889 1.767 1.768-3.889 3.89z"
        fill="currentColor"
      />
    </svg>
  )
}

export const ArrowRight = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.288 12l-3.89 3.89 1.768 1.767L15.823 12l-1.768-1.768-3.889-3.889-1.768 1.768 3.89 3.89z"
        fill="currentColor"
      />
    </svg>
  )
}

export const ArrowDown = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.11 12.178L16 8.287l1.768 1.768-5.657 5.657-1.768-1.768-3.889-3.889 1.768-1.768 3.889 3.89z"
        fill="currentColor"
      ></path>
    </svg>
  )
}
